// PrePostLearning.tsx

import React, {useEffect} from 'react';
import {getPageSection} from '@shared/services/service-handlers/PrivateService';
import {useAppContext} from '@context/AppContext';
import {CircularProgress} from '@mui/material';
import {LoaderDiv} from '@components/card/CardComponentStyles';
import {useLocation, useNavigate} from 'react-router-dom';
import FormConstants from '@shared/constants/FormConstants';
import {
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  LMS_IS_ADMIN,
  LMS_TYPE,
  PARAMS_KEY
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import TabsComponent from '@modules/home/main/sub-modules-menu/tabsComponent/TabsComponent';
import ApplicableToPage from '../Prepostlearning/ApplicableTo';
import BasicsForm from '../Prepostlearning/BasicsForm';
import TemplateEditor from '../Prepostlearning/Certificate/CertificatePreview';
import ExpenseManager from '../Prepostlearning/Costprepostlearning';
import CreateCertificate from '../Prepostlearning/CreateCertificate';
import FeedbackFormCreation from '../Prepostlearning/FeedbackFormCreation';
import GradingSystem from '../Prepostlearning/GradingSystem';
import LearningObjectivesForm from '../Prepostlearning/Learningoutcomes';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
// interface PrePostLearningProps {
//   // Define any props you need, such as handlers for submit actions
//   module: string;
// }
interface AssignMembersProps {
  uiFieldsData: any;
}
const Settings = ({uiFieldsData}: AssignMembersProps): React.ReactElement => {
  const navigate = useNavigate();
  const [tabData, setTabData] = React.useState<any>(uiFieldsData);
  const [loader, setLoader] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState<string>('Basics');
  const [fieldsUIData, setFieldsUIData] = React.useState<any>({});
  const {
    appState: {applicationName}
  } = useAppContext();
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );

  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const section = query.get('section');
  const onRoleChange = async (item: any) => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: recordId,
      [LMS_TYPE]: lmstype,
      [LMS_IS_ADMIN]: lmsisAdmin
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=${section}&subsection=${item}`,
      {
        state: {}
      }
    );
  };

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      setLoader(true);
      if (uiFieldsData === null || uiFieldsData === undefined) {
        const res = await getPageSection(
          applicationName,
          'course_management',
          'settings'
        );
        setTabData(res.searchForm);
      } else {
        setTabData(uiFieldsData.searchForm);
      }
      setLoader(false);
      if (activeTab === 'Basics') {
        onRoleChange(activeTab);
      }
    };
    fetchData();
  }, []);

  const handleActiveTabChange = (tabName: string) => {
    const activeTabDetails = tabData?.sub_sections?.find(
      (section: any) => section.name === tabName
    );

    setActiveTab(tabName);
    onRoleChange(tabName);
    setFieldsUIData(activeTabDetails);
  };
  // useEffect(() => {
  //   // Fetch data from the API
  //   const fetchData = async () => {
  //     setLoader(true);
  //     const res = await getPageSection(
  //       applicationName,
  //       'course_management',
  //       'settings'
  //     );
  //     setTabData(res.searchForm);
  //     setLoader(false);
  //     if (activeTab === 'Basics') {
  //       onRoleChange(activeTab);
  //       // handleActiveTabChange(activeTab)
  //     }
  //   };
  //   fetchData();
  // }, []);

  return (
    <div>
      {!loader ? (
        <>
          <TabsComponent
            sectionUIData={tabData}
            sectionRowsData={[]}
            module="settings"
            handleActiveTabChange={handleActiveTabChange}
          />
          {activeTab === 'Basics' && fieldsUIData?.label === 'Basics' && (
            <BasicsForm tabname={activeTab} formdata={fieldsUIData} />
          )}
          {activeTab === 'Learning_objective' && (
            <LearningObjectivesForm
              tabname={activeTab}
              formdata={fieldsUIData}
            />
          )}
          {activeTab === 'applicable_to' && <ApplicableToPage />}
          {/* {activeTab === 'branding' && <Branding />} */}
          {activeTab === 'grade_configuration' && <GradingSystem />}
          {activeTab === 'cost' && <ExpenseManager />}
          {activeTab === 'create_certificate' && <CreateCertificate />}
          {/* {activeTab === 'post_learning_activities' && <PostLearningActivities />} */}
          {activeTab === 'feedback' && <FeedbackFormCreation />}
          {activeTab === 'certificates' && <TemplateEditor />}
        </>
      ) : (
        <LoaderDiv>
          <CircularProgress />
        </LoaderDiv>
      )}
    </div>
  );
};

export default Settings;
